import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function TopTechProductReviewsLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-[22px] font-semibold text-white tablet:gap-0 tablet:text-[15px]">
      <svg {...attributes} width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1102_5821)">
          <g clipPath="url(#clip1_1102_5821)">
            <path
              d="M13.2436 24.1487H35.5793C36.674 24.1487 37.5696 25.0399 37.5696 26.1494V26.886C37.5696 27.9863 36.683 28.8866 35.5793 28.8866H13.2436C12.149 28.8866 11.2534 27.9954 11.2534 26.886V26.1494C11.2534 25.049 12.14 24.1487 13.2436 24.1487Z"
              fill="white"
            />
            <path
              d="M34.5794 24.6035C35.4298 24.6035 36.1173 25.2946 36.1173 26.1495V26.8861C36.1173 27.7409 35.4298 28.432 34.5794 28.432H12.2437C11.3933 28.432 10.7058 27.7409 10.7058 26.8861V26.1495C10.7058 25.2946 11.3933 24.6035 12.2437 24.6035H34.5794ZM34.5794 23.6941H12.2437C10.9048 23.6941 9.80115 24.7945 9.80115 26.1495V26.8861C9.80115 28.232 10.8958 29.3414 12.2437 29.3414H34.5794C35.9183 29.3414 37.0219 28.2411 37.0219 26.8861V26.1495C37.0219 24.8036 35.9273 23.6941 34.5794 23.6941Z"
              fill="black"
            />
            <path
              d="M33.9781 3.58716H11.6515C10.5523 3.58716 9.66125 4.48289 9.66125 5.58783V22.1116C9.66125 23.2165 10.5523 24.1122 11.6515 24.1122H33.9781C35.0773 24.1122 35.9683 23.2165 35.9683 22.1116V5.58783C35.9683 4.48289 35.0773 3.58716 33.9781 3.58716Z"
              fill="white"
            />
            <path
              d="M33.9782 4.04197C34.8285 4.04197 35.5161 4.73311 35.5161 5.58794V22.1117C35.5161 22.9665 34.8285 23.6577 33.9782 23.6577H11.6515C10.8012 23.6577 10.1136 22.9665 10.1136 22.1117V5.58794C10.1136 4.73311 10.8012 4.04197 11.6515 4.04197H33.9872M33.9782 3.13257H11.6515C10.3127 3.13257 9.20898 4.23294 9.20898 5.58794V22.1117C9.20898 23.4576 10.3036 24.5671 11.6515 24.5671H33.9872C35.3261 24.5671 36.4298 23.4667 36.4298 22.1117V5.58794C36.4298 4.24203 35.3351 3.13257 33.9872 3.13257H33.9782Z"
              fill="black"
            />
            <path
              d="M33.0917 21.5298V6.16094C33.0917 5.93493 32.9094 5.75171 32.6846 5.75171L12.9452 5.75171C12.7204 5.75171 12.5381 5.93493 12.5381 6.16094V21.5298C12.5381 21.7558 12.7204 21.939 12.9452 21.939H32.6846C32.9094 21.939 33.0917 21.7558 33.0917 21.5298Z"
              stroke="black"
              strokeMiterlimit="10"
            />
            <path
              d="M3.46446 10.4258H14.2931C15.3877 10.4258 16.2833 11.317 16.2833 12.4265V27.677C16.2833 28.7774 15.3967 29.6777 14.2931 29.6777H3.46446C2.36984 29.6777 1.47424 28.7865 1.47424 27.677V12.4265C1.47424 11.3261 2.3608 10.4258 3.46446 10.4258Z"
              fill="white"
            />
            <path
              d="M14.2931 10.8806C15.1435 10.8806 15.831 11.5717 15.831 12.4266V27.6772C15.831 28.532 15.1435 29.2231 14.2931 29.2231H3.46452C2.61415 29.2231 1.92662 28.532 1.92662 27.6772V12.4266C1.92662 11.5717 2.61415 10.8806 3.46452 10.8806H14.2931ZM14.2931 9.97119H3.46452C2.12564 9.97119 1.02197 11.0716 1.02197 12.4266V27.6772C1.02197 29.0231 2.11659 30.1325 3.46452 30.1325H14.2931C15.632 30.1325 16.7357 29.0322 16.7357 27.6772V12.4266C16.7357 11.0807 15.641 9.97119 14.2931 9.97119Z"
              fill="black"
            />
            <path
              d="M14.4017 12.4358H3.34691C3.12208 12.4358 2.93982 12.619 2.93982 12.845V27.2499C2.93982 27.4759 3.12208 27.6591 3.34691 27.6591H14.4017C14.6265 27.6591 14.8088 27.4759 14.8088 27.2499V12.845C14.8088 12.619 14.6265 12.4358 14.4017 12.4358Z"
              stroke="black"
              strokeMiterlimit="10"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1102_5821">
            <rect width="36" height="36" fill="white" transform="translate(0.0219727 0.132568)" />
          </clipPath>
          <clipPath id="clip1_1102_5821">
            <rect width="37" height="27" fill="white" transform="translate(1.02197 3.13257)" />
          </clipPath>
        </defs>
      </svg>

      <span>Top Tech Product Reviews</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
